import { Component } from '@angular/core';

@Component({
  selector: 'wfm-ellipsis',
  templateUrl: './ellipsis.component.html',
  styleUrls: ['./ellipsis.component.scss']
})
export class EllipsisComponent {}
